import React from 'react';
import PropTypes from 'prop-types';
import { StyledNavLink } from './styled';
import useTheme from '../../hooks/useTheme';

const NavigationItem = ({ children, to, exact, strict, isActive }) => {
    const theme = useTheme();
    return (
        <StyledNavLink
            to={to}
            exact={exact}
            strict={strict}
            isActive={isActive}
            activeStyle={{
                backgroundColor: theme.colors.white
            }}
        >
            {children}
        </StyledNavLink>
    );
};

NavigationItem.propTypes = {
    children: PropTypes.node,
    to: PropTypes.string,
    exact: PropTypes.bool,
    strict: PropTypes.bool,
    isActive: PropTypes.func
};

NavigationItem.defaultProps = {
    exact: false,
    strict: false,
    isActive: undefined
};

export default React.memo(NavigationItem);